import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询列表
export function query(requestBody) {
  return request({
    url: URL.finance.accountingDocument.query,
    method: 'post',
    data: requestBody
  })
}

// 获取详情
export function detail(requestBody) {
  return request({
    url: URL.finance.accountingDocument.detail,
    method: 'post',
    data: requestBody
  })
}

// 新增/修改保存
export function save(requestBody) {
  return request({
    url: URL.finance.accountingDocument.save,
    method: 'post',
    data: requestBody
  })
}

// 新增/修改保存 批量
export function batchSave(requestBody) {
  return request({
    url: URL.finance.accountingDocument.batchSave,
    method: 'post',
    data: requestBody
  })
}

// 删除
export function remove(requestBody) {
  return request({
    url: URL.finance.accountingDocument.remove,
    method: 'post',
    data: requestBody
  })
}

// 修改对方凭证号
export function updateTargetDocumentNo(requestBody) {
  return request({
    url: URL.finance.accountingDocument.updateTargetDocumentNo,
    method: 'post',
    data: requestBody
  })
}

// 审核凭证/取消审核
export function verify(requestBody) {
  return request({
    url: URL.finance.accountingDocument.verify,
    method: 'post',
    data: requestBody
  })
}

// 红冲凭证
export function reverse(requestBody) {
  return request({
    url: URL.finance.accountingDocument.reverse,
    method: 'post',
    data: requestBody
  })
}

// 检查是否导出
export function checkDocumentIsExport(requestBody) {
  return request({
    url: URL.finance.accountingDocument.checkDocumentIsExport,
    method: 'post',
    data: requestBody
  })
}

// 检查辅助核算项
export function checkMapping(requestBody) {
  return request({
    url: URL.finance.accountingDocument.checkMapping,
    method: 'post',
    data: requestBody
  })
}

// 金蝶验证必填项
export function checkDocumentNotNull(requestBody) {
  return request({
    url: URL.finance.accountingDocument.checkDocumentNotNull,
    method: 'post',
    data: requestBody
  })
}

// 金蝶精斗云验证必填项
export function checkDocumentByJdJDY(requestBody) {
  return request({
    url: URL.finance.accountingDocument.checkDocumentByJdJDY,
    method: 'post',
    data: requestBody
  })
}

// 金蝶EAS导出凭证
export function exportExcelByJDEAS(requestBody) {
  return request({
    url: URL.finance.accountingDocument.exportExcelByJDEAS,
    method: 'post',
    data: requestBody
  })
}

// 金蝶星空云导出凭证
export function exportExcelByJDYXK(requestBody) {
  return request({
    url: URL.finance.accountingDocument.exportExcelByJDYXK,
    method: 'post',
    data: requestBody
  })
}

// 金蝶云星辰导出凭证
export function exportExcelByJDYXC(requestBody) {
  return request({
    url: URL.finance.accountingDocument.exportExcelByJDYXC,
    method: 'post',
    data: requestBody
  })
}

// 用友U8导出凭证
export function exportExcelByYyu8(requestBody) {
  return request({
    url: URL.finance.accountingDocument.exportExcelByYyu8,
    method: 'post',
    data: requestBody
  })
}

// 第三方中间表欧坚
export function exportExcelByOj(requestBody) {
  return request({
    url: URL.finance.accountingDocument.exportExcelByOj,
    method: 'post',
    data: requestBody
  })
}

// 用友U8V16.5导出凭证
export function exportExcelByYYU8V16(requestBody) {
  return request({
    url: URL.finance.accountingDocument.exportExcelByYYU8V16,
    method: 'post',
    data: requestBody
  })
}

// 导出凭证
export function voucherExport(requestBody) {
  return request({
    url: URL.finance.accountingDocument.voucherExport,
    method: 'post',
    data: requestBody
  })
}

// 生成凭证
export function generateVoucher(requestBody) {
  return request({
    url: URL.finance.accountingDocument.generateVoucher,
    method: 'post',
    data: requestBody
  })
}

// 批量生成凭证
export function batchGenerateVoucher(requestBody) {
  return request({
    url: URL.finance.accountingDocument.batchGenerateVoucher,
    method: 'post',
    data: requestBody
  })
}

// 生成凭证：期末调汇
export function generateAdjustRateAccountingDocument(requestBody) {
  return request({
    url: URL.finance.accountingDocument.generateAdjustRateAccountingDocument,
    method: 'post',
    data: requestBody
  })
}

// 生成凭证：损益结转
export function generateCarryOverAccountingDocument(requestBody) {
  return request({
    url: URL.finance.accountingDocument.generateCarryOverAccountingDocument,
    method: 'post',
    data: requestBody
  })
}

// 检测断号
export function checkLossDocumentNo(requestBody) {
  return request({
    url: URL.finance.accountingDocument.checkLossDocumentNo,
    method: 'post',
    data: requestBody
  })
}

// 更新凭证
export function updateAccountingDocument(requestBody) {
  return request({
    url: URL.finance.accountingDocument.updateAccountingDocument,
    method: 'post',
    data: requestBody
  })
}

// 金蝶EAS导出凭证：直接对接EAS
export function exportExcelByDIRECTJDEAS(requestBody) {
  return request({
    url: URL.finance.accountingDocument.exportExcelByDIRECTJDEAS,
    method: 'post',
    data: requestBody
  })
}
export function queryActualAmountAccountingDocument(data) {
  return request({
    url: URL.finance.accountingDocument.queryActualAmountAccountingDocumentUrl,
    method: 'post',
    data
  })
}

export function validateVoucherForExportJDYXK(data) {
  return request({
    url: URL.finance.accountingDocument.validateVoucherForExportJDYXK,
    method: 'post',
    data
  })
}

// 金蝶精斗云导出凭证
export function exportJdJDY(requestBody) {
  return request({
    url: URL.finance.accountingDocument.exportJdJDY,
    method: 'post',
    data: requestBody
  })
}

// 查看导出凭证请求日志
export function queryApiReqLog(fkUuid) {
  return request({
    url: URL.finance.accountingDocument.queryApiReqLog,
    method: 'get',
    params: { fkUuid }
  })
}

// 用友T+CLOUD凭证
export function exportYYTCLOUD(requestBody) {
  return request({
    url: URL.finance.accountingDocument.exportYYTCLOUD,
    method: 'post',
    data: requestBody
  })
}

// 查询T+CLOUD凭证
export function queryYYTCLOUD(requestBody) {
  return request({
    url: URL.finance.accountingDocument.queryYYTCLOUD,
    method: 'post',
    data: requestBody
  })
}

// 刷新openToken
export function refreshTcloudToken(requestBody) {
  return request({
    url: URL.finance.accountingDocument.refreshTcloudToken,
    method: 'post',
    data: requestBody
  })
}

// 根据分录获取对应费用
export function queryRelevanceChargeFunc(params) {
  return request({
    url: URL.finance.accountingDocument.queryRelevanceChargeUrl,
    method: 'get',
    params
  })
}

// 根据发票查询凭证
export function queryInvoiceAccountingDocument(data) {
  return request({
    url: URL.finance.accountingDocument.queryInvoiceAccountingDocumentUrl,
    method: 'post',
    data
  })
}

// 根据水单查询凭证
export function queryActualAmountAccountingDocument2(data) {
  return request({
    url: URL.finance.accountingDocument.queryActualAmountAccountingDocument2Url,
    method: 'post',
    data
  })
}

// 检查辅助核算项: 根据账套
export function checkMappingByAccountSet(requestBody) {
  return request({
    url: URL.finance.accountingDocument.checkMappingByAccountSet,
    method: 'post',
    data: requestBody
  })
}

// 第三方中间表欧坚: 根据账套
export function exportExcelByOjByAccountSet(requestBody) {
  return request({
    url: URL.finance.accountingDocument.exportExcelByOjByAccountSet,
    method: 'post',
    data: requestBody
  })
}
